module.exports = "https://static.wanderu.com/ui-react/_next/static/media/thenewyorker-x2.977277ae.png";